import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../../redux/store'
import { fetchFundData, clearFundSeries, fetchSeriesOnly, fetchPerformanceForSerie, fetchDraftOnly } from '../../../../../redux/fundSeriesSlice'
import { IFundDraft, IFundSeriesResponse, IPerformanceRecord } from '../../../../services/FundDraftService'

export const useFundSeries = (fundId: string | undefined) => {
  const dispatch = useDispatch<AppDispatch>()
  const {
    data,
    draft,
    performanceRecords,
    status,
    fundId: loadedFundId,
  } = useSelector((state: RootState) => state.fundSeries)

  useEffect(() => {
    if (!fundId) return
    if (status === 'idle' || loadedFundId !== fundId) {
      dispatch(fetchFundData(fundId))
    }
  }, [fundId, status, loadedFundId, dispatch])

  const refetch = () => {
    if (!fundId) return
    dispatch(clearFundSeries())
  }

  const refetchSeriesOnly = () => {
    if (!fundId) return
    dispatch(fetchSeriesOnly(fundId))
  }

  const refetchPerformanceForSerie = (serieCode: string) => {
    if (!fundId) return
    dispatch(fetchPerformanceForSerie({ fundId, serieCode }))
  }

  const refetchDraft = () => {
    if (!fundId) return
    dispatch(fetchDraftOnly(fundId))
  }

  return {
    data: data as IFundSeriesResponse | null,
    draft: draft as IFundDraft | null,
    performanceRecords: performanceRecords as Record<string, IPerformanceRecord[]>,
    isLoading: status === 'loading',
    refetch,
    refetchSeriesOnly,
    refetchPerformanceForSerie,
    refetchDraft,
  }
}
